import moment from "moment";
import _ from "underscore";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { storeUtils } from "./util";
import { subdivisionStore } from "../stores/subdivision";
import { territoryStore } from "../stores/territory";
import { ServerActions } from "../actions/serverActions";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { SchematicAPI } from "../actions/schematicAPI";
import { SchematicActions } from "../actions/schematicActions";

const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var CHANGE_EVENT = "change";

var TYPES = Constants.RestrictionTypes;
var TABS = Constants.Tabs;

var _collapsed = false;
var _openVoidedDialog = false;
//index of all the tabs, form: index of which form type, then index of tab on each form follows
//if you change the default form tab number then you have to change the default form type in restrictionRequest.js
var _tabIndex = { form: 1, a: 3, b: 2, c: 2, tcm: 2, history: 1, recent: 1 };

//form Color
var _formBColor = false;
var _formAColor = false;
var _pollSuccessfulFor = "";
var _currentFormType = "A";
var _formASubTabTypeVal = null;
var _formBSubTabTypeVal = "request";
var _formCSubTabTypeVal = null;
var _formTcmSubTabTypeVal = null;
var _subTabTypeVal = null;

//batch variables
var _batchMode = false;
var _selectedList = [];
var _currentBatch = 0;
var _canBatchSubmit = false;
var _batchType = "";
var _selectedBatchType = "";
var _batchForms = [];
var _reasonList = [];

var _requestListLoading = false;
var _issuedListLoading = false;
var _restrictionLoading = false;
let _recentListLoading = false;
var _previousTab;

var _historyListLoading = false;
var _historyList = [];

//Array to store the issueList  and requestList
var _issuedListA = [];
var _issuedListB = [];
let _issuedListC = [];
let _issuedListTCM = [];
var _requestListA = [];
var _requestListB = [];
let _recentList = [];

let _recentListSortBy = null;
let _recentListSortDirection = null;

var _activeRestrictionList = []; //Array to pull all of the active restrictions from the database
let _activeRequestList = [];
let _showFieldFormEntryTab = false;

function formType() {
  switch (_tabIndex.form) {
    case 1:
      return TYPES.A;
    case 2:
      return TYPES.B;
    case 3:
      return "history";
    case 4:
      return TYPES.C;
    case 5:
      return TYPES.TCM;
    case 6:
      return TYPES.RECENT;
    default:
      _currentFormType = TYPES.A;
      return "";
  }
}

function resetBatch() {
  _batchMode = false;
  _selectedList = [];
  _currentBatch = 0;
  _canBatchSubmit = false;
  _batchType = "";
  _selectedBatchType = "";
  _batchForms = [];
  _reasonList = [];
}

function stateDescription() {
  var tabState =
    _tabIndex.form.toString() + _tabIndex[formType().toLowerCase()].toString();
  switch (tabState) {
    case "11":
      return TABS.issuedFormA;
    case "12":
      return TABS.requestFormA;
    case "13":
      return TABS.entryFormA;
    case "21":
      return TABS.issuedFormB;
    case "22":
      return TABS.requestsFormB;
    case "23":
      return TABS.entryFormB;
    case "31":
      return TABS.history;
    case "41":
      return TABS.issuedFormC;
    case "42":
      return TABS.entryFormC;
    case "52":
      return TABS.entryFormTCM;
    case "51":
      return TABS.issuedFormTCM;
    case "61":
      return TABS.recentTab;
    default:
      return TABS.unknown;
  }
}

function allowableBatchTypes() {
  var types = [];

  switch (stateDescription()) {
    case TABS.issuedFormA:
      return [Constants.BatchTypes.MODIFY, Constants.BatchTypes.VOID];
    case TABS.requestFormA:
      return [Constants.BatchTypes.APPROVE, Constants.BatchTypes.REJECT];
    case TABS.entryFormA:
      return [Constants.BatchTypes.ISSUE];
    case TABS.issuedFormB:
      return [Constants.BatchTypes.VOID];
    case TABS.requestsFormB:
      return [Constants.BatchTypes.APPROVE, Constants.BatchTypes.REJECT];
    case TABS.entryFormB:
      return [Constants.BatchTypes.ISSUE];
    default:
      return [];
  }

  return types;
}

function clearItemLists() {
  _activeRestrictionList = [];
  _activeRequestList = [];
  _issuedListA = [];
  _issuedListB = [];
  _issuedListC = [];
  _issuedListTCM = [];
  _requestListA = [];
  _requestListB = [];
  _recentList = [];
}

function reloadActiveListForSub() {
  const sub = subdivisionStore.getSelectedSub();
  if (sub !== 0) ServerActions.getActiveListForSub(sub);
}

function reloadActiveListForSubAndFormType(formType, subTabTypeVal) {
  // console.log(
  //   "====Selected FormType  " +
  //     formType +
  //     ", Selected subTabTypeVal " +
  //     subTabTypeVal
  // );
  const sub = subdivisionStore.getSelectedSub();
  if (sub !== 0)
    ServerActions.getActiveListForSubAndFormType(sub, formType, subTabTypeVal);
}

function reloadRecentListForSub() {
  ServerActions.getRecentListForSub(subdivisionStore.getSelectedSub());
}

var _pendingTabChange = null;
var dispatchToken = dispatcher.register(function (action) {

  switch (action.type) {
    case ActionTypes.VOIDED_MODAL_CLOSE:
      
      _openVoidedDialog = false;
      try {
        var restriction = restrictionRequestStore.getForm && restrictionRequestStore.getForm();
        var syncId = restriction && restriction.syncId;
        var restrictionNumber = restriction && restriction.controlNumber;
        var dsId = restriction.dispatcherId;
        var subdivision = restriction && restriction.subdivision;
        if (syncId) {
          ServerActions.dropAlert({ syncId, restrictionNumber, dsId, subdivision });
        }
      } catch (e) {}
      
      _previousTab = _tabIndex;
      _tabIndex = {
        form: 1,
        a: 3,
        b: 3,
        c: 2,
        tcm: 2,
        history: 1,
        recent: 1,
      };
      
      setTimeout(function() {
        
        dispatcher.dispatch({
          type: ActionTypes.TAB_CHANGED,
          tabIndex: 1, // main Form A tab
          tabChanged: "form"
        });
        // Switch to the entryFormA subtab ("a": 3)
        dispatcher.dispatch({
          type: ActionTypes.TAB_CHANGED,
          tabIndex: 3,
          tabChanged: "a"
        });
      }, 0);

      try {
        // Use the canonical schematic reset that preserves TMDS layers and not the DOM.
        // This will dispatch SCHEMATIC_UPDATE_COMPLETE and clear the track list as needed.
        SchematicActions.resetContainerPreserveLayers({ clearSelectedTracks: true, clearTrackList: true, centerAndZoom: true });
      } catch (e) {}

      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.NEW_BATCH_INDEX:
      _currentBatch = action.batchIndex;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TAB_CHANGED:
      if (!_batchMode) {
        _previousTab = null;

        _tabIndex[action.tabChanged] = action.tabIndex;
        _showFieldFormEntryTab = false;

        dispatcher.waitFor([subdivisionStore.dispatchToken]);
        dispatcher.waitFor([territoryStore.dispatchToken]);
        if (action.tabChanged === "form" && action.tabIndex === 6) {
          //If they are changing to the recent tab, refresh that list
          reloadActiveListForSubAndFormType(_currentFormType, null);
          reloadRecentListForSub();
        } else {
          _recentListSortBy = null;
          _recentListSortDirection = null;
          if (action.tabChanged === "form") {
            console.log("==> USER SELECTED MAIN TAB");

            if (Constants.Tabs[action.tabIndex] === "A") {
              _currentFormType = Constants.Tabs[action.tabIndex];
              reloadActiveListForSubAndFormType(
                Constants.Tabs[action.tabIndex],
                _formASubTabTypeVal
              );
            } else if (Constants.Tabs[action.tabIndex] === "B") {
              _currentFormType = Constants.Tabs[action.tabIndex];
              reloadActiveListForSubAndFormType(
                Constants.Tabs[action.tabIndex],
                _formBSubTabTypeVal
              );
            } else if (Constants.Tabs[action.tabIndex] === "C") {
              _currentFormType = Constants.Tabs[action.tabIndex];
              reloadActiveListForSubAndFormType(
                Constants.Tabs[action.tabIndex],
                _formCSubTabTypeVal
              );
            }
            if (Constants.Tabs[action.tabIndex] === "TCM") {
              _currentFormType = Constants.Tabs[action.tabIndex];
              reloadActiveListForSubAndFormType(
                Constants.Tabs[action.tabIndex],
                _formTcmSubTabTypeVal
              );
            }
          } else {
            console.log("==> USER SELECTED SUB TAB UNDER MAIN FORM TYPE");
            _subTabTypeVal = null;
            if (Constants.Tabs[action.tabIndex] === "A") {
              if (action.tabChanged === "a") {
                _formASubTabTypeVal = "restriction";
                reloadActiveListForSubAndFormType(
                  _currentFormType,
                  _formASubTabTypeVal
                );
                _subTabTypeVal = _formASubTabTypeVal;
              } else if (action.tabChanged === "b") {
                _formBSubTabTypeVal = "restriction";
                reloadActiveListForSubAndFormType(
                  _currentFormType,
                  _formBSubTabTypeVal
                );
                _subTabTypeVal = _formBSubTabTypeVal;
              } else if (action.tabChanged === "c") {
                _formCSubTabTypeVal = "restriction";
                reloadActiveListForSubAndFormType(
                  _currentFormType,
                  _formCSubTabTypeVal
                );
                _subTabTypeVal = _formCSubTabTypeVal;
              } else if (action.tabChanged === "tcm") {
                _formTcmSubTabTypeVal = "restriction";
                reloadActiveListForSubAndFormType(
                  _currentFormType,
                  _formTcmSubTabTypeVal
                );
                _subTabTypeVal = _formTcmSubTabTypeVal;
              }
            } else if (Constants.Tabs[action.tabIndex] === "B") {
              if (action.tabChanged === "a") {
                _formASubTabTypeVal = "request";
                reloadActiveListForSubAndFormType(
                  _currentFormType,
                  _formASubTabTypeVal
                );
                _subTabTypeVal = _formASubTabTypeVal;
              } else if (action.tabChanged === "b") {
                _formBSubTabTypeVal = "request";
                reloadActiveListForSubAndFormType(
                  _currentFormType,
                  _formBSubTabTypeVal
                );
                _subTabTypeVal = _formBSubTabTypeVal;
              } else if (action.tabChanged === "c") {
                _formCSubTabTypeVal = null;
                reloadActiveListForSubAndFormType(
                  _currentFormType,
                  _formCSubTabTypeVal
                );
                _subTabTypeVal = _formCSubTabTypeVal;
              } else if (action.tabChanged === "tcm") {
                _formTcmSubTabTypeVal = null;
                reloadActiveListForSubAndFormType(
                  _currentFormType,
                  _formTcmSubTabTypeVal
                );
                _subTabTypeVal = _formTcmSubTabTypeVal;
              }
            }
          }
        }
        _events.trigger(CHANGE_EVENT);
      }

      break;

    case ActionTypes.SUBDIVISION_CHANGED:
      //Force all lists to show as loading and clear the list
      _requestListLoading = true;
      _issuedListLoading = true;
      clearItemLists();
      dispatcher.waitFor([subdivisionStore.dispatchToken]);
      dispatcher.waitFor([territoryStore.dispatchToken]);
      _showFieldFormEntryTab = false;
      if (stateDescription() === TABS.recentTab) {
        //Only refresh the recent list if they are on the recent tab
        reloadActiveListForSubAndFormType(_currentFormType, null);
        reloadRecentListForSub();
      } else {
        reloadActiveListForSubAndFormType(_currentFormType, _subTabTypeVal);
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.CHANGE_BATCH_MODE:
      _batchMode = action.batchMode;
      if (!_batchMode) {
        resetBatch();
      } else {
        _selectedBatchType = allowableBatchTypes()[0];
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.BATCH_SELECT:
      var index = _selectedList.indexOf(action.requestId);
      if (index > -1) {
        _selectedList.splice(index, 1);
      } else {
        _selectedList.push(action.requestId);
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.OPENING_RESTRICTION:
      _restrictionLoading = true;
      _events.trigger(ActionTypes.CHANGE_EVENT);
      break;

    case ActionTypes.OPEN_FORM_B_REQUEST:
      //Make sure that the form is converted correctly before trying to change tabs
      dispatcher.waitFor([restrictionRequestStore.dispatchToken]);
      if (action.form) {
        _previousTab = _tabIndex;

        _tabIndex = {
          form: 2,
          a: 2,
          b: 3,
          c: 2,
          tcm: 2,
          history: 1,
          recent: 1,
        };
      }
      _restrictionLoading = false;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.OPEN_FORM_A_REQUEST:
      //Make sure that the form is converted correctly before trying to change tabs
      dispatcher.waitFor([restrictionRequestStore.dispatchToken]);
      if (action.form) {
        _previousTab = _tabIndex;

        _tabIndex = {
          form: 1,
          a: 3,
          b: 3,
          c: 2,
          tcm: 2,
          history: 1,
          recent: 1,
        };
      }
      _restrictionLoading = false;
      _openVoidedDialog = !!action.openVoidedDialog;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.OPEN_FORM_B_RESTRICTION:
      //Make sure that the form is converted correctly before trying to change tabs
      dispatcher.waitFor([restrictionRequestStore.dispatchToken]);
      if (action.form) {
        _previousTab = _tabIndex;
        _tabIndex = {
          form: 2,
          a: 2,
          b: 3,
          c: 2,
          tcm: 2,
          history: 1,
          recent: 1,
        };
      }
      _restrictionLoading = false;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.OPEN_FORM_C_RESTRICTION:
      //Make sure that the form is converted correctly before trying to change tabs
      dispatcher.waitFor([restrictionRequestStore.dispatchToken]);
      if (action.form) {
        _previousTab = _tabIndex;

        _tabIndex = {
          form: 4,
          a: 2,
          b: 3,
          c: 2,
          tcm: 2,
          history: 1,
          recent: 1,
        };
      }
      _restrictionLoading = false;
      _showFieldFormEntryTab = true;
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.OPEN_TCM_RESTRICTION:
      //Make sure that the form is converted correctly before trying to change tabs
      dispatcher.waitFor([restrictionRequestStore.dispatchToken]);
      if (action.form) {
        _previousTab = _tabIndex;
        _tabIndex = {
          form: 5,
          a: 2,
          b: 3,
          c: 2,
          tcm: 2,
          history: 1,
          recent: 1,
        };
      }
      _restrictionLoading = false;
      _showFieldFormEntryTab = true;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.OPEN_FORM_A_RESTRICTION:
      //Make sure that the form is converted correctly before trying to change tabs
      dispatcher.waitFor([restrictionRequestStore.dispatchToken]);
      if (action.form) {
        _previousTab = _tabIndex;
        _tabIndex = {
          form: 1,
          a: 3,
          b: 3,
          c: 2,
          tcm: 2,
          history: 1,
          recent: 1,
        };
      }
      _restrictionLoading = false;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SERVER_ACTION_FAILED:
      _restrictionLoading = false;
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.GO_TO_PREVIOUS_TAB:
      if (_previousTab) {
        _tabIndex = _previousTab;
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SUB_ACTIVE_LIST_LOADING:
      _requestListLoading = true;
      _issuedListLoading = true;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SUB_RECENT_LIST_LOADING:
      _recentListLoading = true;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SUB_ACTIVE_LIST_LOADED:
      dispatcher.waitFor([subdivisionStore.dispatchToken]);
      const sub = subdivisionStore.getSelectedSub();
      if (sub === action.sub) {
        _issuedListLoading = false;
        _requestListLoading = false;
        _activeRestrictionList = action.list.activeRestrictions;
        _activeRequestList = action.list.activeRequests

        _issuedListA = _.where(_activeRestrictionList, {
          type: "A",
          status: "restriction",
        });
        _issuedListA = _issuedListA.sort(function (a, b) {
          return a.workStartMp - b.workStartMp;
        });
        _issuedListB = _.where(_activeRestrictionList, {
          type: "B",
          status: "restriction",
        });
        _issuedListB = _issuedListB.sort(function (a, b) {
          //Sort by workStartDate then StartMp
          let aTime = moment(a.workStartDate);
          let bTime = moment(b.workEndDate);
          if (aTime > bTime) return 1;
          else if (aTime < bTime) return -1;
          else {
            return a.workStartMp - b.workStartMp;
          }
        });
        _issuedListC = _.where(_activeRestrictionList, {
          type: "C",
          status: "restriction",
        });
        //Sort single, multi, all by control number
        let issuedListCSingle = _.where(_issuedListC, { subdivision: sub });
        issuedListCSingle = issuedListCSingle.sort(function (a, b) {
          return a.controlNumber - b.controlNumber;
        });
        let issuedListCMulti = _.where(_issuedListC, { subdivision: "MULTI" });
        issuedListCMulti = issuedListCMulti.sort(function (a, b) {
          return a.controlNumber - b.controlNumber;
        });
        let issuedListCAll = _.where(_issuedListC, { subdivision: "ALL" });
        issuedListCAll = issuedListCAll.sort(function (a, b) {
          return a.controlNumber - b.controlNumber;
        });

        _issuedListC = issuedListCSingle;
        _issuedListC = _issuedListC.concat(issuedListCMulti);
        _issuedListC = _issuedListC.concat(issuedListCAll);
        _issuedListTCM = _.where(_activeRestrictionList, {
          type: "TCM",
          status: "restriction"
        });
        _issuedListTCM = _issuedListTCM.sort(function (a, b) {
          return a.controlNumber - b.controlNumber;
        });

        _requestListA = _.where(_activeRequestList, { type: "A", status: "request" });

        if (_requestListA.length) {
          _requestListA = _requestListA.sort(function (a, b) {
            //Sort by lastModifiedTimeStamp
            let aTime = moment(a.lastModifiedTimeStamp);
            let bTime = moment(b.lastModifiedTimeStamp);
            if (aTime > bTime) return 1;
            else if (aTime < bTime) return -1;
            else return 0;
          });
        }
        // else {
        //   _requestListA = _.where(_activeRestrictionList, {
        //     formAColor: "Found_Pending_Form_A_Request",
        //   });
        // }

        _requestListB = _.where(_activeRequestList, { type: "B", status: "request" });

        if (_requestListB.length) {
          _requestListB = _requestListB.sort(function (a, b) {
            let aTime = moment(a.workStartDate);
            let bTime = moment(b.workStartDate);
            if (aTime > bTime) return 1;
            else if (aTime < bTime) return -1;
            else {
              return a.workStartMp - b.workStartMp;
            }
          });
        }
        // else {
        //   _requestListB = _.where(_activeRestrictionList, {
        //     formBColor: "Found_Pending_Form_B_Request",
        //   });
        // }
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SUB_RECENT_LIST_LOADED:
      _recentListLoading = false;
      _recentList = action.list;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.RECENT_LIST_SORT_CHANGED:
      _recentListSortBy = action.sortBy;
      _recentListSortDirection = action.sortDirection;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.HISTORY_LIST_LOADING:
      _historyListLoading = true;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.HISTORY_LIST_LOADED:
      _historyListLoading = false;
      _historyList = action.data;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.LIST_FAILED_LOADING:
      _issuedListLoading = false;
      _requestListLoading = false;
      _historyListLoading = false;
      _recentListLoading = false;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TERRITORY_DETAILS_LOADED:
      //we have the list of subs for this territory now, so get the issued list
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.RESET_FORM_B_RESTRICTION:
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TERRITORY_CHANGED:
      if (action.selectedTerritory !== "0") {
        //get the requests
        reloadActiveListForSubAndFormType(_currentFormType, null);
      }
      _events.trigger(CHANGE_EVENT);

      break;
    case ActionTypes.BATCH_VALIDATION_SUCCESSFUL:
      _batchForms[_currentBatch] = action.form;
      if (action.validationOnly) {
        _canBatchSubmit = true;
      } else {
        _canBatchSubmit = false;
        _currentBatch = action.newIndex;
        if (
          _batchType !== Constants.BatchTypes.ISSUE &&
          _batchForms[_currentBatch] == null
        ) {
          ServerActions.openRequestOrRestriction(_selectedList[_currentBatch]);
        }
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SELECT_BATCH_TYPE:
      _selectedBatchType = action.batchType;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.START_BATCH:
      _batchType = _selectedBatchType;
      if (_batchType !== Constants.BatchTypes.ISSUE) {
        ServerActions.openRequestOrRestriction(_selectedList[_currentBatch]);
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.BATCH_SUBMIT_SUCCESSFUL:
      resetBatch();
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TOGGLE_COLLAPSE:
      _collapsed = action.newState;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.POLL_SUCCESSFUL:
      if (action.formTypeSubmitted) {
        if (action.formTypeSubmitted === "A") {
          _tabIndex = {
            form: 1,
            a: 2,
            b: 3,
            c: 2,
            tcm: 2,
            history: 1,
            recent: 1,
          };
        } else if (action.formTypeSubmitted === "B") {
          _tabIndex = {
            form: 2,
            a: 2,
            b: 2,
            c: 2,
            tcm: 2,
            history: 1,
            recent: 1,
          };
        } else if (action.formTypeSubmitted === "C") {
          _tabIndex = {
            form: 4,
            a: 2,
            b: 2,
            c: 1,
            tcm: 2,
            history: 1,
            recent: 1,
          };
        } else if (action.formTypeSubmitted === "T") {
          _tabIndex = {
            form: 5,
            a: 2,
            b: 2,
            c: 1,
            tcm: 1,
            history: 1,
            recent: 1,
          };
        }
      }
      reloadActiveListForSubAndFormType(_currentFormType, _subTabTypeVal);

      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.USER_CHANGED:
      _formAColor = false;
      _formBColor = false;
      reloadActiveListForSubAndFormType(_currentFormType, null);
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.BACKGROUND_RELOAD:
      if (stateDescription() === TABS.recentTab) {
        //Only refresh the recent list if they are on the recent tab
        reloadActiveListForSubAndFormType(_currentFormType, null);
        reloadRecentListForSub();
      }
      reloadActiveListForSubAndFormType(_currentFormType, _subTabTypeVal);
      _events.trigger(CHANGE_EVENT);
      break;
    default:
    //no op
  }
}); //end of dispatch token

//public api
export const tabsStore = {
  subscribe: _events.on,
  unsubscribe: _events.off,
  dispatchToken,
  isCollapsed: function () {
    return _collapsed;
  },
  getTabIndex: function () {
    return _tabIndex;
  },
  getHistory: function () {
    return _historyList;
  },
  requestListLoading: function () {
    return _requestListLoading;
  },
  issuedListLoading: function () {
    return _issuedListLoading;
  },
  recentListLoading: function () {
    return _recentListLoading;
  },
  historyListLoading: function () {
    return _historyListLoading;
  },
  restrictionLoading: function () {
    return _restrictionLoading;
  },
  openVoidedDialog: function () {
    return _openVoidedDialog;
  },
  clearOpenVoidedDialog: function () {
    _openVoidedDialog = false;
  },
  getFormType: function () {
    return formType();
  },
  inBatchMode: function () {
    return _batchMode;
  },
  selectedList: function () {
    return _selectedList;
  },
  currentBatch: function () {
    return _currentBatch;
  },
  canBatchSubmit: function () {
    return _canBatchSubmit;
  },
  stateDescription: function () {
    return stateDescription();
  },
  batchType: function () {
    return _batchType;
  },
  allowableBatchTypes: function () {
    return allowableBatchTypes();
  },
  selectedBatchType: function () {
    return _selectedBatchType;
  },
  batchForms: function () {
    return _batchForms;
  },
  reasonList: function () {
    return _reasonList;
  },
  formAColor: function () {
    return _formAColor;
  },
  formBColor: function () {
    return _formBColor;
  },
  aRequestList: function () {
    return _requestListA;
  },
  bRequestList: function () {
    return _requestListB;
  },
  aIssuedList: function () {
    return _issuedListA;
  },
  bIssuedList: function () {
    return _issuedListB;
  },
  cIssuedList: function () {
    return _issuedListC;
  },
  tcmIssuedList: function () {
    return _issuedListTCM;
  },
  recentIssuedList: function () {
    return _recentList;
  },
  pollSuccessfulFor: function () {
    return _pollSuccessfulFor;
  },
  showFormCEntryTab: function () {
    return _showFieldFormEntryTab;
  },
  getRecentListSortBy: function () {
    return _recentListSortBy;
  },
  getRecentListSortDirection: function () {
    return _recentListSortDirection;
  },
};
